import qs from "qs";
import {apiVoissa} from "../../libs/api";



export const fetchMedias = (query = {}, config = {}) => {
    let sort = ['-createdAt', '-count.like', '-count.like', '-count.like', '-count.comment'];
    query = {...query, sort: sort[query.sort] || sort[0]};
    return apiVoissa.get(`/medias?${qs.stringify(query)}`, config)
};

export const fetchCategorizedMedias = (query = {}, config = {}) => {
    query = qs.stringify(query).replaceAll("%5B0%5D", "").replaceAll("%5B1%5D", "");
    return apiVoissa.get(`/medias/categorized?${query}`, config);
};

export const fetchCategorizedMediasCount = (query = {}, config = {}) => {
    query = qs.stringify(query).replaceAll("%5B0%5D", "").replaceAll("%5B1%5D", "");
    return apiVoissa.get(`/medias/categorized-count?${query}`, config);
};

export const moveMedia = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/move`, data, config);
export const reportMedia = (mediaId = null, data = {}, config = {}) => apiVoissa.post(`/medias/${mediaId}/reporting`, data, config);

export const fetchMedia = (mediaId = null, query = {}, config = {}) => apiVoissa.get(`/medias/${mediaId}?${qs.stringify(query)}`, config);
export const updateMedia = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}`, data, config);
export const updateCoverVideoFile = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-cover-video-file`, data, config);
export const updateCoverVideoFfmpeg = (mediaId = null, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-cover-video-ffmpeg`, data, config);
export const updateMediaCategories = (mediaId, data = {}, config = {}) => apiVoissa.patch(`/medias/${mediaId}/update-categories`, data, config);
export const deleteMedia = (mediaId = null, config = {}) => apiVoissa.delete(`/medias/${mediaId}`, config);

export const setMediaCountViews = (id = null, config = {}) => apiVoissa.patch(`/medias/${id}/view`, config);

export const fetchMediasSfw = (query = {}, config = {}) => apiVoissa.get(`/medias/sfw-moderate?${qs.stringify(query)}`, config);
export const updateMediasSfw = (data = {}, config = {}) => apiVoissa.patch(`/medias/sfw-moderate`, data, config);

export const createMediaBookmark = (mediaId = null, config = {}) => apiVoissa.post(`/medias/${mediaId}/bookmarks`, config);
export const deleteMediaBookmark = (mediaId = null, config = {}) => apiVoissa.delete(`/medias/${mediaId}/bookmarks`, config);


export const MEDIAS_KEY = `medias`;
export const MEDIAS_CATEGORIZED_KEY = `medias-categorized`;
export const MEDIAS_CATEGORIZED_COUNT_KEY = `medias-categorized-count`;
export const MEDIAS_TAGS_KEY = `medias-tags`;
export const MEDIAS_SFW_KEY = `medias-sfw`;

export const MEDIA_KEY = `media`;
export const MEDIA_SET_COUNT_KEY = `media-set-count`;